require('../../libs/loading-attribute-polyfill/loading-attribute-polyfill.min.js')
window.jQuery = window.$ = require('../../libs/jquery/jquery.min.js')
require('../../libs/@fancyapps/fancybox/jquery.fancybox.min.js')
require('../../libs/@fancyapps/fancybox/jquery.fancybox.min.css')
window.Swiper = require('../../libs/swiper/js/swiper.min.js')
require('../../libs/inputmask/inputmask.min.js')
window.axios = require('../../libs/axios/axios.min.js')